import {useState, useEffect} from 'react';
import {Link, useLocation} from 'react-router-dom';
import {useRegistration} from '../../../contexts/RegistrationContext';

import styled from 'styled-components';
import config from '../../../config';
import LabelWithInfo from '../../atoms/LabelWithInfo';
import {SubInner, TabHeader} from '../../atoms/CommonParts';
import {ScannedDevice} from '.';
import {useApp} from '../../../contexts/AppContext';
import strings from '../../../strings';
import {useAuth} from '../../../contexts/UserContext';
import {NotLoginedHeaderArea} from '../../organisms/CommonParts';

const Page = styled.div``;

const LoginContent = styled.div`
  padding-top: 40px;
`;

const InputField = styled.input`
  display: block;
  width: 100%;
  font-size: 18px;
  padding: 8px 15px !important;
  background-color: #fff;
  border-radius: 4px;
`;

const ErrorMessage = styled.div`
  border: 1px solid #FF7323;
  font-size: 14px;
  font-weight: bold;
  line-height: 19px;
  text-align: center;
  padding: 20px 20px;
  margin-top: 30px;

  a {
    color: #FF7323;
    text-decoration: underline;
  }
`;

const ForgotLinkArea = styled.div`
  margin-top: 14px;
  text-align: right;

  a {
    color: #000000;
    text-decoration: underline;
    font-size: 12px;
    @media ${config.layout.wide} {
      font-size: 14px;
    }
    font-weight: 500;
  }
`;

const KeepMeLogin = styled.div`
  text-align: center;
  margin: 30px auto;
  max-width: 230px;
  @media ${config.layout.wide} {
    max-width: 100%;
  }

  input {
    display: none;

    &:checked {
      & + label {
        &:before {
        }
      }
    }
  }

  label {
    position: relative;
    font-size: 12px;
    font-weight: bold;
    margin-left: 7px;
    padding-left: 28px;
    text-align: left;

    &:before {
      content: "";
      background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"><g id="長方形_167" data-name="長方形 167" fill="%23fff" stroke="%23000" stroke-width="1"><rect width="20" height="20" stroke="none"/><rect x="0.5" y="0.5" width="19" height="19" fill="none"/></g></svg>');
      display: block;
      width: 20px;
      height: 20px;
      background-size: 20px 20px;
      position: absolute;
      left: 0;
      top: -1px;
    }

    a {
      color: #000000;
    }
  }
`;

const DontHaveOneWrap = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 20px;
`;

const GotLostInSignup = styled.div`
  width: calc((100% - 20px) / 2);
  flex: 0 0 auto;

  border: 1px solid #000000;
  margin: 30px auto 0;
  text-align: center;
  padding: 20px 0;
  border-radius: 2px;

  p {
    margin: 0;
    padding: 0;
    font-size: 14px;
    font-weight: bold;
    color: #000000;
    margin-bottom: 5px;
  }

  a {
    color: #000000;
    text-decoration: underline;
    font-size: 12px;
    font-weight: 500;
  }
`;

const DontHaveOne = styled.div`
  width: calc((100% - 20px) / 2);
  flex: 0 0 auto;

  border: 1px solid #000000;
  margin: 30px auto 0;
  text-align: center;
  padding: 20px 0;
  border-radius: 2px;

  p {
    margin: 0;
    padding: 0;
    font-size: 14px;
    font-weight: bold;
    color: #000000;
    margin-bottom: 5px;
  }

  a {
    color: #000000;
    text-decoration: underline;
    font-size: 12px;
    font-weight: 500;
  }
`;

const RegistrationLabel = styled.div`
  margin-top: 40px;
  margin-bottom: 40px;
  text-align: center;
  font-size: 14px;
  font-weight: bold;
  padding: 0 20px;
  @media ${config.layout.wide} {
    text-align: left;
  }
`;

const LoginWrap = styled.div`
  padding-top: 10px;
  @media ${config.layout.wide} {
    margin-top: 40px;
  }
`;

const Readme = styled.div`
  margin-top: 40px;
  font-size: 12px;
  line-height: 18px;
  font-weight: 500;
  color: #9A9A9A;
  @media ${config.layout.wide} {
    margin-top: 30px;
  }
`;

function AddMoreDeviceTab({onClickAnotherTab}) {
  let location = useLocation();
  const [errorElm, setErrorElm] = useState('');
  const [errorFieldSet, setErrorFieldSet] = useState(new Set());
  const auth = useAuth();

  const onAddMoreDevice = (index) => {
    console.log(index);
    onClickAnotherTab();
  };

  const from = `${location.pathname}${location.search}`;

  function setErrorByCode(code) {
    switch (code) {
      default:
        setErrorElm(<span>Unknown error. Please retry later.</span>);
        break;
      case 401022: // Error Message 4
        setErrorElm(<span>Invalid login or password.</span>);
        //setErrorFieldSet(new Set(["email", "password"]));
        break;

      case 401021: // Error Message 3
        setErrorElm(
            <span>Invalid AlphaTheta Account log in or password.</span>,
        );
        //setErrorFieldSet(new Set(["email", "password"]));
        break;
      case 401025: // Error Message 2
      case 401024: // Error Message 2
      case 401026: // Error Message 2
        setErrorElm(
            <span>
            You need to create a venue account to use this service.{' '}
              <a
                  href="#"
                  onClick={() => {
                    onClickAnotherTab();
                  }}
              >
              Sign up your venue
            </a>
          </span>,
        );
        break;

      case 401023: // Error Message 1
        setErrorElm(
            <span>
            This KUVO ID is not valid.
            <br/>
            Please enter the valid KUVO ID.
          </span>,
        );
        //setErrorFieldSet(new Set(["venue_code"]));
        break;
      case 401027: //
        setErrorElm(<span>This venue is currently unavailable.</span>);
        break;
    }
  }

  function handleSubmit(event) {
    event.preventDefault();

    let formData = new FormData(event.currentTarget);
    let venue_code = formData.get('venue_code');
    let email = formData.get('email');
    let password = formData.get('password');
    let keep = !!formData.get('keep');

    auth.signin(venue_code, email, password, keep, (err) => {
      setErrorElm('');
      setErrorFieldSet(new Set());
      if (err) {
        const status = (err.response && err.response.status) || 500;
        const code =
            (err.response && err.response.data && err.response.data.code) ||
            500;

        setErrorByCode(code);

        console.error(err.response, status, code);
      } else {
        //  navigate(from, { replace: true });
      }
    });
  }

  return (
      <>
        <TabHeader
            buttons={[
              {
                title: 'Registration',
              },
              {
                title: 'Add more devices',
              },
            ]}
            selectedIndex={1}
            onClickTab={onAddMoreDevice}
        />
        <RegistrationLabel>
          Register another device to your venue account.
        </RegistrationLabel>
        <hr className="content-border"/>
        {errorElm ? (
            <SubInner>
              <ErrorMessage>{errorElm}</ErrorMessage>
            </SubInner>
        ) : (
            ''
        )}
        <LoginWrap>
          <form onSubmit={handleSubmit}>
            <SubInner>
              <LabelWithInfo
                  text={strings.venue_code}
                  labelclassname="login-field-label"
                  style={{
                    marginBottom: 20,
                  }}
              >
                <div>{strings.venue_code_ex}</div>
              </LabelWithInfo>
              <InputField
                  name="venue_code"
                  type="text"
                  required
                  autoComplete="off"
                  defaultValue={''}
                  className={errorFieldSet.has('venue_code')
                      ? 'error'
                      : 'normal'}
              />
              <ForgotLinkArea>
                <Link
                    to={`/forgot-venue-code/?from=${encodeURIComponent(from)}`}>
                  {strings.forgot_your_venue_code}
                </Link>
              </ForgotLinkArea>

              <LabelWithInfo
                  text={strings.pioneer_dj_account}
                  labelclassname="login-field-label"
                  style={{
                    marginTop: 10,
                    marginBottom: 20,
                  }}
              >
                <div>
                  {strings.pioneer_dj_account_ex}
                  <span className="pc">&nbsp;</span>
                  <br className="sp"/>-{' '}
                  <a
                      href={process.env.REACT_APP_PDJ_DOMAIN +
                          '/en/account/register/'}
                      target="_blank"
                      rel="noopener"
                  >
                    {strings.pioneer_dj_account_ex_link}
                  </a>
                </div>
              </LabelWithInfo>

              <InputField
                  name="email"
                  type="email"
                  className={errorFieldSet.has('email') ? 'error' : 'normal'}
                  required
                  defaultValue={''}
                  autoComplete="email"
              />

              <LabelWithInfo
                  text={strings.password}
                  labelclassname="login-field-label"
                  style={{
                    marginTop: 20,
                    marginBottom: 20,
                  }}
              >
                <div>{strings.password_ex}</div>
              </LabelWithInfo>

              <InputField
                  name="password"
                  type="password"
                  className={errorFieldSet.has('password') ? 'error' : 'normal'}
                  required
                  autoComplete="current-password"
              />

              <ForgotLinkArea>
                <a
                    href={process.env.REACT_APP_PDJ_DOMAIN +
                        '/en/account/login/'}
                    target="_blank"
                    rel="noopener"
                >
                  {strings.forgot_your_password}
                </a>
              </ForgotLinkArea>

              <button
                  type="submit"
                  className="dark-button center-fixed primary"
                  style={{
                    margin: '40px  auto 0',
                  }}
              >
                <span>{strings.button_login}</span>
              </button>
              <KeepMeLogin>
                <input
                    id="keep_me_logged_in"
                    name="keep"
                    type="checkbox"
                    defaultChecked
                />
                <label htmlFor="keep_me_logged_in" className={'checkbox-label'}>
                  {strings.keep_me_logged_in}
                </label>
              </KeepMeLogin>
            </SubInner>
          </form>
        </LoginWrap>
      </>
  );
}

function RegistrationTab({onClickAnotherTab, agreed, setAgreed}) {
  const registration = useRegistration();
  let location = useLocation();

  const [errorElm, setErrorElm] = useState('');
  const [errorFieldSet, setErrorFieldSet] = useState(new Set());

  const onAddMoreDevice = (index) => {
    console.log(index);
    onClickAnotherTab();
  };

  function setErrorByCode(code) {
    switch (code) {
      default:
        setErrorElm(<span>Unknown error. Please retry later.</span>);
        break;
      case 401013:
        setErrorElm(
            <span>
            Invalid email address or password.
            <br/>
            If you don't have AlphaTheta Account -{' '}
              <a
                  href={process.env.REACT_APP_PDJ_DOMAIN +
                      '/en/account/register/'}
                  target="_blank"
                  rel="noopener"
              >
              Create now.
            </a>
          </span>,
        );
        break;

      case 401042: {
        const from = `${location.pathname}${location.search}`;
        setErrorElm(
            <span>
              You already have a venue account. Go{' '}
              <Link to={`/login?from=${encodeURIComponent(from)}`}>
                <span>log-in.</span>
              </Link>
              <br/>
              <br/>
              Do you want to create another venue account? Sign up with
              different AlphaTheta Account.{' '}
              <a
                  href={process.env.REACT_APP_PDJ_DOMAIN +
                      '/en/account/register/'}
                  target="_blank"
                  rel="noopener"
              >
                Create new AlphaTheta Account.
              </a>
            </span>,
        );
      }
        break;
    }
  }

  function handleSubmit(event) {
    event.preventDefault();

    let formData = new FormData(event.currentTarget);
    let email = formData.get('email');
    let password = formData.get('password');
    let keep = !!formData.get('keep');
    if (!keep) {
      return;
    }

    registration.signin(email, password, (err) => {
      setErrorElm('');
      setErrorFieldSet(new Set());
      if (err) {
        const status = (err.response && err.response.status) || 500;
        const code =
            (err.response && err.response.data && err.response.data.code) ||
            500;

        setErrorByCode(code);

        console.error(err.response, status, code);
      } else {
        //  navigate(from, { replace: true });
        window.scrollTo(0, 0);
        registration.dispatch({
          type: 'step1',
        });
      }
    });
  }

  return (
      <>
        <TabHeader
            buttons={[
              {
                title: 'Registration',
              },
              {
                title: 'Add more devices',
              },
            ]}
            selectedIndex={0}
            onClickTab={onAddMoreDevice}
        />

        {errorElm ? (
            <SubInner>
              <ErrorMessage>{errorElm}</ErrorMessage>
            </SubInner>
        ) : (
            ''
        )}

        <form onSubmit={handleSubmit}>
          <SubInner>
            <LoginContent>
              <LabelWithInfo
                  text={'AlphaTheta Account'}
                  labelclassname="login-field-label"
                  style={{
                    marginBottom: 20,
                  }}
              >
                <div>
                  You need a AlphaTheta Account to sign in to the venue menu.
                  Don't have one?
                  <span className="pc">&nbsp;</span>
                  <br className="sp"/>-{' '}
                  <a
                      href={process.env.REACT_APP_PDJ_DOMAIN +
                          '/en/account/register/'}
                      target="_blank"
                      rel="noopener"
                  >
                    Sign up now
                  </a>
                </div>
              </LabelWithInfo>

              <InputField
                  name="email"
                  type="email"
                  className={errorFieldSet.has('email') ? 'error' : 'normal'}
                  required
                  defaultValue={''}
                  autoComplete="email"
              />

              <LabelWithInfo
                  text={'Password'}
                  labelclassname="login-field-label"
                  style={{
                    marginTop: 30,
                    marginBottom: 20,
                  }}
              >
                <div>Please enter your AlphaTheta Account password.</div>
              </LabelWithInfo>

              <InputField
                  name="password"
                  type="password"
                  className={errorFieldSet.has('password') ? 'error' : 'normal'}
                  required
                  autoComplete="current-password"
              />

              <ForgotLinkArea>
                <a
                    href={process.env.REACT_APP_PDJ_DOMAIN +
                        '/en/account/login/'}
                    target="_blank"
                    rel="noopener"
                >
                  *Forgot your password?
                </a>
              </ForgotLinkArea>

              <KeepMeLogin>
                <input
                    id="keep_me_logged_in"
                    name="keep"
                    type="checkbox"
                    defaultChecked={agreed}
                    onChange={(e) => {
                      setAgreed(e.target.checked);
                    }}
                />
                <label htmlFor="keep_me_logged_in" className={'checkbox-label'}>
                  I have read and agree to the{' '}
                  <Link to="/terms-of-use/" target={'_blank'}>
                    Terms of Use.
                  </Link>
                </label>
              </KeepMeLogin>

              <button
                  type="submit"
                  className="dark-button center-fixed primary"
                  style={{
                    margin: '40px  auto 0',
                  }}
                  disabled={!agreed}
              >
                <span>Create venue account</span>
              </button>
            </LoginContent>
          </SubInner>


          <DontHaveOneWrap>
            <GotLostInSignup>
              <p>Got lost in signup?</p>
              <Link to={`/registration/wizard`}>
                Signup tutorial
              </Link>
            </GotLostInSignup>
            <DontHaveOne>
              <p>{strings.dont_have_one}</p>
              <a
                  href={process.env.REACT_APP_PDJ_DOMAIN +
                      '/en/account/register/'}
                  target="_blank"
                  rel="noopener"
              >
                {strings.create_pioneer_dj_account}
              </a>
            </DontHaveOne>
          </DontHaveOneWrap>

        </form>
      </>
  );
}

export default function RegistrationPageStep0() {
  const location = useLocation();
  const [tabIndex, setTabIndex] = useState(
      location.state && location.state.add ? 1 : 0,
  );
  const [agreed, setAgreed] = useState(false);
  const {hideHeader} = useApp();

  useEffect(() => {
    hideHeader();
    document.title = 'Registration';
    try {
      let st = window.history.state;
      if (st && st.usr && st.usr.add) {
        delete st.usr.add;
        window.history.replaceState(st, document.title);
      }
    } catch (e) {
      console.error(e);
    }
  }, []);

  const changeTab = function() {
    if (tabIndex == 0) {
      setTabIndex(1);
    } else {
      setTabIndex(0);
    }
  };

  return (
      <Page>
        <NotLoginedHeaderArea
            style={{
              'margin-bottom': 40,
            }}
        />
        <ScannedDevice/>
        {tabIndex == 0 ? (
            <RegistrationTab
                onClickAnotherTab={changeTab}
                agreed={agreed}
                setAgreed={setAgreed}
            />
        ) : (
            <AddMoreDeviceTab onClickAnotherTab={changeTab}/>
        )}
      </Page>
  );
}
